import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faSync, faEye, faArrowUp, faArrowDown, faFile, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './PedidosData.css'
import 'jspdf-autotable';
import baseURL from '../../url';
import moneda from '../../moneda';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const obtenerRutaImagen = (imagen) => {
    if (!imagen) return '';
    if (imagen.startsWith('http://') || imagen.startsWith('https://') || imagen.startsWith('data:')) {
        return imagen;
    }
    const cleanPath = imagen.startsWith('/') ? imagen.slice(1) : imagen;
    return `${baseURL}/${cleanPath}`;
};

export default function PedidosData() {
    const [pedidos, setPedidos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoEstado, setNuevoEstado] = useState('');
    const [pedido, setPedido] = useState({});
    const [profesionales, setProfesionales] = useState({});

    const [selectedSection, setSelectedSection] = useState('texto');

    const [filtroMesa, setFiltroMesa] = useState('');
    const [filtroTipoCategoria, setFiltroTipoCategoria] = useState('');
    const [filtroProfesional, setFiltroProfesional] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('');
    const [filtroDesde, setFiltroDesde] = useState('');
    const [filtroHasta, setFiltroHasta] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [numeroTelefono, setNumeroTelefono] = useState('');
    
    // Estados para comprobante de pago
    const [uploadingProof, setUploadingProof] = useState(false);
    
    useEffect(() => {
        cargarPedidos();
        cargarProfesionales();
    }, []);

    const cargarProfesionales = () => {
        fetch(`${baseURL}/profesionalesGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data.profesionales) {
                    setProfesionales(data.profesionales);
                } else {
                    setProfesionales([]);
                }
            })
            .catch(error => {
                console.error('Error al cargar mesas:', error);
                setProfesionales([]);
            });
    };

    const cargarPedidos = () => {
        fetch(`${baseURL}/pedidoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setPedidos(data.pedidos.reverse() || []);
                console.log(data.pedidos)
            })
            .catch(error => console.error('Error al cargar pedidos:', error));
    };

    // Función para renderizar ícono de comprobante
    const renderComprobanteIcon = (pedido) => {
        // Si es efectivo o método no especificado, no mostrar nada
        if (pedido.payment_method_name === 'Efectivo' || !pedido.payment_method_id) {
            return <span className='noComprobante'>-</span>;
        }

        // Si tiene comprobante
        if (pedido.payment_proof_path) {
            return (
                <button
                    className='btnComprobante btnComprobanteVerde'
                    onClick={() => descargarComprobante(pedido.idPedido)}
                    title='Descargar comprobante'
                >
                    <FontAwesomeIcon icon={faFileDownload} />
                </button>
            );
        }

        // No tiene comprobante
        return (
            <button
                className='btnComprobante btnComprobanteGris'
                onClick={() => toast.info('Este pedido no tiene comprobante de pago')}
                title='Sin comprobante'
            >
                <FontAwesomeIcon icon={faFile} />
            </button>
        );
    };

    // Función para descargar comprobante
    const descargarComprobante = (idPedido) => {
        window.open(`${baseURL}/downloadPaymentProof.php?id=${idPedido}`, '_blank');
    };

    // Función para subir comprobante desde admin
    const subirComprobanteAdmin = async (idPedido, file) => {
        if (!file) return;

        if (file.size > 5 * 1024 * 1024) {
            toast.error('El archivo es demasiado grande. Máximo 5MB');
            return;
        }

        setUploadingProof(true);
        const formData = new FormData();
        formData.append('idPedido', idPedido);
        formData.append('payment_proof', file);
        formData.append('uploaded_by', 'admin');

        try {
            const response = await fetch(`${baseURL}/uploadPaymentProof.php`, {
                method: 'POST',
                body: formData
            });
            const data = await response.json();

            if (data.success) {
                toast.success('Comprobante subido exitosamente');
                cargarPedidos(); // Recargar la lista
                // Actualizar el pedido actual en el modal
                const pedidoActualizado = pedidos.find(p => p.idPedido === idPedido);
                if (pedidoActualizado) {
                    setPedido({ ...pedidoActualizado, payment_proof_path: data.proof_path });
                }
            } else {
                toast.error(data.message || 'Error al subir comprobante');
            }
        } catch (error) {
            console.error('Error al subir comprobante:', error);
            toast.error('Error al procesar la solicitud');
        } finally {
            setUploadingProof(false);
        }
    };

    const eliminar = (idPedido) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/pedidoDelete.php?idPedido=${idPedido}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarPedidos();
                    })
                    .catch(error => {
                        console.error('Error al eliminar :', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setPedido(item);
        setNuevoEstado(item.estado)
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const handleUpdateText = async (idPedido) => {
        const nuevoEstadoFinal = nuevoEstado !== '' ? nuevoEstado : pedido.estado;
        if(pedido.entrega == "Reserva servicio"){
            pedido.estado_cocina = 'Terminado';
        }
        // Validación 1: No permitir cambiar estado si ya está Rechazado
        if (pedido.estado === 'Rechazado') {
            Swal.fire({
                icon: 'error',
                title: 'Pedido Rechazado',
                text: 'No se puede cambiar el estado de un pedido rechazado.',
            });
            return;
        }
        // Validación de cocina removida porque el sistema no usa cocina
        
        // Validación 3: Confirmación si se va a rechazar
        if (nuevoEstadoFinal === 'Rechazado') {
            const result = await Swal.fire({
                icon: 'warning',
                title: '¿Está seguro de rechazar este pedido?',
                text: 'Esta acción liberará la mesa (si tiene) y no se podrá cambiar el estado después. ¿Desea continuar?',
                showCancelButton: true,
                confirmButtonText: 'Sí, rechazar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#d33',
            });

            if (!result.isConfirmed) {
                return;
            }
        }
        
        const payload = {
            estado: nuevoEstadoFinal,
        };

        if(pedido.entrega == "Reserva servicio"){
            payload.estado_cocina = 'Terminado';
        }

        fetch(`${baseURL}/pedidoPut.php?idPedido=${idPedido}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.success === false || data.error) {
                    Swal.fire(
                        'Error!',
                        data.error || 'Error al actualizar',
                        'error'
                    );
                } else {
                    Swal.fire(
                        'Editado!',
                        data.mensaje || 'Estado actualizado correctamente',
                        'success'
                    );
                    cargarPedidos();
                    cerrarModal();
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };



    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    const filtrados = pedidos.filter(item => {
        const matchTipoCategoria = (!filtroTipoCategoria || (filtroTipoCategoria && (filtroTipoCategoria == "" || (filtroTipoCategoria == "Servicios" && item.entrega == "Reserva servicio") || (filtroTipoCategoria == "Productos" && item.entrega != "Reserva servicio"))));
        const matchProfesional = (!filtroProfesional || (filtroProfesional && filtroProfesional == "" || (filtroProfesional == item.profesional_id)));

        const estadoMatch = !filtroEstado || item.estado.includes(filtroEstado);
        const desdeMatch = !filtroDesde || new Date(item.createdAt) >= new Date(filtroDesde);

        // Incrementamos la fecha "hasta" en un día para que incluya la fecha seleccionada
        const adjustedHasta = new Date(filtroHasta);
        adjustedHasta.setDate(adjustedHasta.getDate() + 1);

        const hastaMatch = !filtroHasta || new Date(item.createdAt) < adjustedHasta;
        return matchProfesional && matchTipoCategoria && estadoMatch && desdeMatch && hastaMatch;
    });


    const recargarProductos = () => {
        cargarPedidos();
    };
    const invertirOrden = () => {
        setPedidos([...pedidos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };
    const descargarExcel = () => {
        let totalGeneral = 0;

        const data = filtrados.map(item => {
            const total = parseFloat(item.total); // Convertir a número
            totalGeneral += total;
            const productos = JSON.parse(item.productos);
            const infoProductos = productos.map(producto => `${producto.titulo} - ${moneda}${producto.precio} - x${producto.cantidad}  `);
            return {
                'ID Pedido': item.idPedido,
                'Estado': item.estado,
                'Nombre': item.nombre,
                'Email': item.email,
                'Telefono': item.telefono,
                'Pago': item.pago,
                'Entrega': item.entrega,
                'Nota': item.nota,
                'Productos': infoProductos.join('\n'),
                'Codigo': item.codigo,
                'Total': `${moneda} ${total.toFixed(2)}`,
                'Fecha': item.createdAt,
            };
        });

        // Formatear el total general
        const formattedTotal = `${moneda} ${totalGeneral.toFixed(2)}`;

        // Agregar fila con el total general
        const totalRow = {

            'ID Pedido': '',
            'Estado': '',
            'Nombre': '',
            'Email': '',
            'Telfono': '',
            'Pago': '',
            'Entrega': '',
            'Nota': '',
            'Productos': '',
            'Codigo': 'Total General:',
            'Total': formattedTotal,
            'Fecha': '',
        };

        data.push(totalRow);

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'pedidos');
        XLSX.writeFile(wb, 'pedidos.xlsx');
    };


    const descargarPDF = () => {
        const pdf = new jsPDF('landscape'); // Orientación horizontal
        pdf.text('Lista de Pedidos', 10, 10);

        const columns = [
            { title: 'ID Pedido', dataKey: 'idPedido' },
            { title: 'Estado', dataKey: 'estado' },
            { title: 'Nombre', dataKey: 'nombre' },
            { title: 'Email', dataKey: 'email' },
            { title: 'Telfono', dataKey: 'telefono' },
            { title: 'Pago', dataKey: 'pago' },
            { title: 'Entrega', dataKey: 'entrega' },
            { title: 'Nota', dataKey: 'nota' },
            { title: 'Productos', dataKey: 'productos' },
            { title: 'Codigo', dataKey: 'codigo' },
            { title: 'Total', dataKey: 'total' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        let totalGeneral = 0;

        const data = filtrados.map(item => {
            const total = parseFloat(item.total); // Convertir a número
            totalGeneral += total;
            const productos = JSON.parse(item.productos);
            const infoProductos = productos.map(producto => `${producto.titulo} - ${moneda}${producto.precio} - x${producto.cantidad}  `);
            return {
                idPedido: item.idPedido,
                estado: item.estado,
                nombre: item.nombre,
                email: item.email,
                telefono: item.telefono,
                pago: item.pago,
                entrega: item.entrega,
                nota: item.nota,
                productos: infoProductos.join('\n'),
                codigo: item.codigo,
                total: `${moneda} ${total.toFixed(2)}`,
                createdAt: item.createdAt,
            };
        });

        // Formatear el total general
        const formattedTotal = `${moneda} ${totalGeneral.toFixed(2)}`;

        // Agregar fila con el total general
        const totalRow = {
            idPedido: '',
            estado: '',
            nombre: '',
            email: '',
            telefono: '',
            pago: '',
            entrega: '',
            nota: '',
            productos: '',
            codigo: 'Total General:',
            total: formattedTotal,
            createdAt: '',
        };

        data.push(totalRow);

        pdf.autoTable({
            head: [columns.map(col => col.title)],
            body: data.map(item => Object.values(item)),
        });

        pdf.save('pedidos.pdf');
    };
    const handleDownloadPDF = () => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        let y = 10;

        // Agregar título
        pdf.setFontSize(10);


        // Obtener los detalles del pedido actualmente mostrado en el modal
        const pedidoActual = pedido;


        // Agregar detalles del pedido al PDF
        const pedidoData = [
            [`ID Pedido:`, `${pedidoActual.idPedido}`],
            [`Estado:`, `${pedidoActual.estado}`],
            [`Nombre:`, `${pedidoActual.nombre}`],
            [`Email:`, `${pedidoActual.email}`],
            [`Telefono:`, `${pedidoActual.telefono}`],
            [`Pago:`, `${pedidoActual.pago}`],
            [`Entrega:`, `${pedidoActual.entrega}`],
            [`Nota:`, `${pedidoActual.nota}`],
            [`Código:`, `${pedidoActual.codigo}`],
            [`Total:`, `${moneda} ${pedidoActual.total}`],
            [`Fecha:`, `${pedidoActual.createdAt}`]
        ];
        pdf.autoTable({
            startY: y,
            head: [['Detalle del pedido', 'Valor']],
            body: pedidoData,
        });
        y = pdf.autoTableEndPosY() + 5;

        y += 5;

        // Obtener los productos del pedido actual
        const productosPedido = JSON.parse(pedidoActual.productos);

        // Generar sección de productos con imágenes y contenido
        for (let i = 0; i < productosPedido.length; i++) {
            if (y + 30 > pdf.internal.pageSize.getHeight()) {
                pdf.addPage();
                y = 10;
            }

            const producto = productosPedido[i];

            pdf.setFontSize(8);

            // Muestra la imagen a la izquierda de los datos del producto
            if (producto.imagen) {
                pdf.addImage(obtenerRutaImagen(producto.imagen), 'JPEG', 15, y, 20, 20); // Ajusta el tamaño de la imagen aquí
            } else {
                // Si no hay URL de imagen, simplemente dejar un espacio en blanco
                pdf.text("Imagen no disponible", 5, y + 15);
            }

            if (producto) {
                pdf.text(`Producto: ${producto.titulo}`, 39, y + 3);
                pdf.text(`Precio: ${moneda} ${producto.precio}`, 39, y + 11);
                pdf.text(`Cantidad: ${producto.cantidad}`, 39, y + 15);
                pdf.text(`${producto.item}`, 39, y + 19);
            }

            y += 25; // Incrementar y para la siguiente posición
        }

        // Guardar el PDF
        pdf.save('pedido.pdf');
    };

    
    const formatDateHour = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);

        return date.toLocaleTimeString("es-AR", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        });
    };


    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString("es-AR", {
            day: "2-digit",
            month: "2-digit"
        });
    };

    const formatDateFull = (dateString) => {
        if (!dateString) return "";
        
        // Reemplazo el espacio por "T" para que Safari y algunos navegadores lo tomen como ISO válido
        const safeDateString = dateString.replace(" ", "T");
        const date = new Date(safeDateString);

        if (isNaN(date)) return ""; // Seguridad

        return date.toLocaleDateString("es-AR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    };


    return (
        <div>
 
            <ToastContainer />
            <div className='deFlexContent'>

                <div className='deFlex2'>

                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                </div>
                <div className='gastosFiltros'>
                    <input type="date" value={filtroDesde} onChange={(e) => setFiltroDesde(e.target.value)} placeholder='Desde' className='filtroInput' />
                    <input type="date" value={filtroHasta} onChange={(e) => setFiltroHasta(e.target.value)} placeholder='Hasta' className='filtroInput' />
                    <select value={filtroTipoCategoria} onChange={(e) => setFiltroTipoCategoria(e.target.value)} className='filtroInput'>
                        <option value="">Tipo pedido</option>
                        <option value="Servicios">Servicios</option>
                        <option value="Productos">Productos</option>
                    </select>
                    <select value={filtroProfesional} onChange={(e) => setFiltroProfesional(e.target.value)} className='filtroInput'>
                        <option value="">Profesional</option>
                        {profesionales && profesionales.length > 0 ? (
                            profesionales.map((prf) => (
                                <option key={prf.id} value={prf.id}>
                                    {prf.nombre} 
                                </option>
                            ))
                        ) : (
                            <option value='' disabled>No hay profesionales disponibles</option>
                        )}
                    </select>
                    <select value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)} className='filtroInput'>
                        <option value="">Estado</option>
                        <option value="Entregado">Entregado</option>
                        <option value="Reservado">Reservado</option>
                        <option value="Disponible">Disponible</option>
                        <option value="Rechazado">Rechazado</option>
                        <option value="Pagado">Pagado</option>
                        <option value="Pendiente">Pendiente</option>
                    </select>
                    
                    <button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>

                </div>

            </div>
             <div className="resumen-dashboard">
                <div className="card-resumen pendiente">
                    <h3>Pendientes</h3>
                    <p>{filtrados.filter(i => i.estado === "Pendiente").length}</p>
                </div>
                <div className="card-resumen entregado">
                    <h3>Entregados</h3>
                    <p>{filtrados.filter(i => i.estado === "Entregado").length}</p>
                </div>

                <div className="card-resumen rechazado">
                    <h3>Rechazados</h3>
                    <p>{filtrados.filter(i => i.estado === "Rechazado").length}</p>
                </div>

                 <div className="card-resumen reservado">
                    <h3>Reservado</h3>
                    <p>{filtrados.filter(i => i.estado === "Reservado").length}</p>
                </div>

                <div className="card-resumen disponible">
                    <h3>Disponible</h3>
                    <p>{filtrados.filter(i => i.estado === "Disponible").length}</p>
                </div>

                <div className="card-resumen dinero">
                    <h3>Pagado( {filtrados.filter(i => i.estado === "Pagado").length} de {filtrados.length} )</h3>
                    <p>{moneda} {filtrados
                        .filter(i => i.estado === "Pagado")
                        .reduce((sum, p) => sum + parseFloat(p.total), 0)
                        .toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                    }</p>
                </div>
            </div>
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Id Pedido</th>
                            <th>Estado</th>
                            <th>Nombre</th>
                            <th>Telefono</th>
                            <th>Entrega</th>
                            <th>Pago</th>
                            <th>Total</th>
                            <th>Fecha</th>
                            <th>Comprobante</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtrados.map(item => (
                            <tr key={item.idPedido}>
                                <td>{item.idPedido}</td>

                                <td style={{
                                    color: item?.estado === 'Pendiente' ? '#DAA520' :
                                        item?.estado === 'Entregado' ? '#0000FF' :
                                            item?.estado === 'Rechazado' ? '#FF0000' :
                                                item?.estado === 'Pagado' ? '#008000' :
                                                    '#000000'
                                }}>
                                    {item?.estado}
                                </td>
                                <td>{item.nombre}</td>
                                <td>{item.telefono}</td>
                                <td>
                                    {item.entrega == "Reserva servicio" ? (
                                        <span>
                                            Día {formatDate(item.startDate)} → 
                                            {formatDateHour(item.startDate)} a {formatDateHour(item.finishDate)}
                                        </span>
                                    ) : (
                                        item.entrega
                                    )}
                                </td>
                                <td>{item.payment_method_name || item.pago}</td>
                                <td style={{ color: '#008000', }}>{moneda} {item.total}</td>
                                <td>{item.createdAt}</td>
                                <td className='comprobanteCol'>
                                    {renderComprobanteIcon(item)}
                                </td>
                                <td>
                                    <button className='eliminar' onClick={() => eliminar(item.idPedido)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                    <button className='editar' onClick={() => abrirModal(item)}>
                                        <FontAwesomeIcon icon={faEye} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Pedido
                                </button>
                                <button onClick={handleDownloadPDF} className='texto'>Descargar PDF</button>
                            </div>

                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>ID Pedido</legend>
                                    <input
                                        value={pedido.idPedido}
                                        disabled

                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input
                                        value={pedido.nombre}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Telefono</legend>
                                    <input
                                        value={pedido.telefono}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Pago</legend>
                                    <input
                                        value={pedido.payment_method_name || pedido.pago}
                                        disabled

                                    />
                                </fieldset>
                                
                                {/* Sección de información de pago */}
                                {pedido.payment_method_id && pedido.payment_method_name !== 'Efectivo' && (
                                    <div className='detalleSeccion'>
                                        <h4>Información de Pago</h4>
                                        {pedido.payment_reference && (
                                            <fieldset>
                                                <legend>Referencia de Pago</legend>
                                                <input
                                                    value={pedido.payment_reference}
                                                    disabled
                                                />
                                            </fieldset>
                                        )}
                                        {pedido.payment_proof_path && (
                                            <fieldset>
                                                <legend>Comprobante de Pago</legend>
                                                <button 
                                                    className='btnVerComprobante' 
                                                    onClick={() => descargarComprobante(pedido.idPedido)}
                                                    type='button'
                                                >
                                                    Ver/Descargar Comprobante
                                                </button>
                                            </fieldset>
                                        )}
                                        {!pedido.payment_proof_path && (
                                            <p className='sinComprobante'>Este pedido no tiene comprobante de pago</p>
                                        )}
                                    </div>
                                )}
                                
                                {/* Opción para subir comprobante desde admin */}
                                {pedido.payment_method_id && pedido.payment_method_name !== 'Efectivo' && (
                                    <div className='uploadSection'>
                                        <label htmlFor='adminProofUpload'>
                                            {pedido.payment_proof_path ? 'Reemplazar comprobante:' : 'Subir comprobante:'}
                                        </label>
                                        <input
                                            id='adminProofUpload'
                                            type='file'
                                            accept='image/*,application/pdf'
                                            onChange={(e) => subirComprobanteAdmin(pedido.idPedido, e.target.files[0])}
                                            disabled={uploadingProof}
                                        />
                                        {uploadingProof && <p className='uploadingText'>Subiendo...</p>}
                                        <small>Formatos permitidos: JPG, PNG, WEBP, PDF (máx. 5MB)</small>
                                    </div>
                                )}
                                
                                <fieldset>
                                    <legend>Entrega</legend>
                                    <input
                                        value={pedido.entrega}
                                        disabled

                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Codigo</legend>
                                    <input
                                        value={pedido.codigo}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Nota</legend>
                                    <input
                                        value={pedido.nota}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Fecha creación</legend>
                                    <input
                                        value={pedido.createdAt}
                                        disabled

                                    />
                                </fieldset>
                                
                                {pedido.descuento_aplicado && parseFloat(pedido.descuento_aplicado) > 0 && (
                                    <>
                                        <fieldset>
                                            <legend>Subtotal</legend>
                                            <input
                                                value={`${moneda} ${(parseFloat(pedido.total) + parseFloat(pedido.descuento_aplicado)).toFixed(2)}`}
                                                disabled
                                            />
                                        </fieldset>
                                        <fieldset>
                                            <legend>Descuento (Cupón: {pedido.codigo})</legend>
                                            <input
                                                value={`-${moneda} ${parseFloat(pedido.descuento_aplicado).toFixed(2)}`}
                                                disabled
                                                style={{ color: '#4CAF50', fontWeight: 'bold' }}
                                            />
                                        </fieldset>
                                    </>
                                )}
                                
                                <fieldset>
                                    <legend>Total Final</legend>
                                    <input
                                        value={`${moneda} ${parseFloat(pedido.total).toFixed(2)}`}
                                        disabled
                                        style={{ fontWeight: 'bold', fontSize: '16px' }}
                                    />
                                </fieldset>
                                { 
                                    pedido.entrega == "Reserva servicio" && (
                                    <>
                                        <fieldset>
                                            <legend>Fecha turno</legend>
                                            <input
                                                value={formatDate(pedido.startDate)}
                                                disabled

                                            />
                                        </fieldset>
                                        <fieldset>
                                            <legend>Hora turno</legend>
                                            <input
                                                value={`${formatDateHour(pedido.startDate)} a ${formatDateHour(pedido.finishDate)}`}
                                                disabled

                                            />
                                        </fieldset>
                                        <fieldset>
                                            <legend>Profesional</legend>
                                            <input
                                                value={`${pedido.profesional_nombre}`}
                                                disabled

                                            />
                                        </fieldset>
                                    </>
                                )}
                                <fieldset>
                                    <legend>Estado</legend>
                                    <select
                                        value={nuevoEstado !== '' ? nuevoEstado : pedido.estado}
                                        onChange={(e) => setNuevoEstado(e.target.value)}
                                    >
                                        <option value={pedido.estado}>{pedido.estado}</option>
                                        { 
                                            pedido.entrega != "Reserva servicio" && (
                                            <option value="Entregado">Entregado</option>
                                        )}
                                        { 
                                            pedido.entrega == "Reserva servicio" && (
                                                <>
                                                    <option value="Reservado">Reservado</option>
                                                    <option value="Disponible">Disponible</option>
                                                </>
                                        )}
                                        { 
                                            pedido.entrega != "Reserva servicio" && (
                                                <option value="Rechazado">Rechazado</option>
                                        )}
                                        <option value="Pagado">Pagado</option>
                                    </select>
                                </fieldset>
                            </div>
                            <div className='cardsProductData'>
                                {JSON.parse(pedido.productos).map(producto => (
                                    <div key={producto.titulo} className='cardProductData'>
                                        <div className='cardProductDataText'>
                                            <h3>{producto.titulo}</h3>
                                            <strong>{moneda} {producto.precio} <span>x{producto.cantidad}</span></strong>
                                            <span>{producto.item}</span>

                                        </div>
                                    </div>
                                ))}
                                
                                {pedido.descuento_aplicado && parseFloat(pedido.descuento_aplicado) > 0 && (
                                    <div className='cupon-info-card'>
                                        <p className='cupon-info-title'>✓ Cupón Aplicado</p>
                                        <p className='cupon-info-codigo'>{pedido.codigo}</p>
                                        <p className='cupon-info-descuento'>
                                            Descuento: -{moneda} {parseFloat(pedido.descuento_aplicado).toFixed(2)}
                                        </p>
                                    </div>
                                )}
                            </div>

                            <button className='btnPost' onClick={() => handleUpdateText(pedido.idPedido)} >Guardar </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
